<meta name="viewport" content="width=device-width, initial-scale=1.0" />

<div class="page-container min-height-100vh"
  [ngClass]="{ 'visibility-visible': showLoginForm, 'visibility-hidden': !showLoginForm }">
  <div class="white-card">
    <div class="login-content start-column-vertical-centered-container ">
      <div class="stretched-aligned-centered-column-container column-gap-1p5625em">
          <app-orca-logo data-qa="login-logo"
            [logoType]="'black'"
            [divStyling]="'orca-logo-login'">
          </app-orca-logo>
        <div class="column-gap-1p5625em stretched-aligned-column-container">
          <div data-qa="login-title"
            class="login-title line-height-120 ">
              Log in
            </div>
          <div
            class="form-container"
            [ngClass]="{ 'no-propagation opacity0p5 no-cursor' : form.disabled }">
            <form
              id="wf-form-Login"
              name="wf-form-Login"
              data-name="Login"
              data-qa="form-login"
              class="vertical-container-simple column-gap-1p25em"
              [formGroup]="form">
              <app-input
                data-qa="login-email"
                class="entrance-input"
                formControlName="email"
                [readonly]="false"
                [maxLength]="256"
                [placeholder]="'Email address'"
                [autofocus]="true"
                [additionalClass]="form.disabled ? 'disabled' : form.controls.email.valid ? '' : 'error'"
              />
              <app-input
                data-qa="login-password"
                class="entrance-input"
                formControlName="password"
                [type]="inputType"
                [readonly]="false"
                [maxLength]="256"
                [placeholder]="'Password'"
                [additionalClass]="form.disabled ? 'disabled' : ''"
                [suffixFirstIcon]="eyeIcon"
                (suffixFirstIconEmitter)="flipPasswordVisibility()"
              />
              <app-invisible-recaptcha
                *ngIf="showRecaptchaV2"
                data-qa="recaptcha-v2"
                #captcha
                [siteKey]="siteV2Key"
                (resolved)="onCaptchaV2Resolved($event)"
                (errored)="onCaptchaV2Errored($event)"
              />
              <div *ngIf="secondsLeft >= 0" class="error centered-column-container"> Next attempt will be able in {{ secondsLeft }} seconds </div>
              <app-button
                data-name="loginButton"
                data-qa="login-button"
                data-wait="Please wait..."
                type="submit"
                class="entrance-button submit-button w-button bold500 clickable items-center"
                [size]="'medium'"
                [disabled]="form.disabled || (showRecaptchaV2 && !captchaV2Token)"
                [ngClass]="form.disabled || (showRecaptchaV2 && !captchaV2Token) ? 'cursor-not-allowed opacity0p5' : ''"
                (buttonClick)="confirmLogin(onSubmit())">
                Log in
              </app-button>
            </form>
          </div>
          <div class="flex justify-center items-center mobile-gap-0p625 gap-0.625">
            <span class="mobile-font-1 font-2em">Trouble logging in?</span>
            <a (click)="changePage('forgotPassword')" data-name="forgotPasswordLink" data-qa="login-forgot-password-link" class="link bold500 mobile-font-1 line-height-120 clickable">Reset password</a>
          </div>
        </div>
        <div class="signup text-align-center stretched-aligned-centered-column-container">
          <div class="font-2em bold500 line-height-120">Don’t have an account yet?</div>
          <a [href]="WEBSITE_PROD_ORCA" class="request-demo-button line-height-120 w-button clickable centered-vertically-column-container">Request a demo</a>
        </div>
      </div>
      <div class="column-gap-0p625em black-9 text-align-center vertical-container-simple line-height-120 ">
        <div class="login-footer-links centered-row-container ">
          <a target="_blank"
            [href]="PROD_SERVC_PRIVACY_POLICY">Privacy policy</a>
          <div>•</div>
          <a target="_blank"
            [href]="PROD_ORCA_TERM_OF_USE">Terms of use</a>
          <div>•</div>
          <a href="#" class="termly-display-preferences">Cookie management</a>
        </div>
        <div>Powered by SerVC © {{year}}</div>
      </div>
    </div>
  </div>
</div>
